define(function (require, exports, module) {
    var Config = {
        debug: false,
        isSubmited: false,
        isSupportWebP: false,
        isIE: function () { //ie?
            if (!!window.ActiveXObject || "ActiveXObject" in window)
                return true;
            else
                return false;
        }
    };

    Config.serviceInterface = {
        getTime: "//specials.jd.hk/getTime.do",
        getTrackInfo: "//home.jd.hk/asyn/getTrackInfo.do",
        getIdNumber: "//home.jd.hk/asyn/checkOrderIdCard.do",
        confirmReceipt: "//home.jd.hk/asyn/confirmReceipt.do",
        cancelOrder: "//home.jd.hk/asyn/cancelOrder.do",
        deleteCoupon: "//home.jd.hk/asyn/delUserCoupon.do?",
        getCouponCount: "//home.jd.hk/coupon/count.do",
        getOrderState: "//club.jd.com/mycomments/getListOrderHandleState.action",
        getOrderState_local: "//home.jd.hk/asyn/getOrderHandleState.do",
        deleteOrder: "//home.jd.hk/asyn/recycleOrder.do",
        cancelFollow: "//home.jd.hk/asyn/unfollow.do",
        ajaxCancelFollowShop: "//home.jd.hk/asyn/unFollowByshopId.do",
        getHistoricEmail: "//home.jd.hk/asyn/storeNotifyBaseInfo.do",
        sendStoreNotifyEmail: "//home.jd.hk/asyn/storeNotify.do",
        addToCart: "//cart.jd.com/gate.action",
        loadShopSkus: "//diviner.jd.com/diviner",
        getCitys: "//home.jd.hk/asyn/getCitys.do",
        getCountries: "//home.jd.hk/asyn/getCountries.do",
        getTowns: "//home.jd.hk/asyn/getTowns.do",
        deleteAddressById: "//home.jd.hk/asyn/delAddressById.do",
        updateAddress: "//home.jd.hk/asyn/updateAddress.do",
        insertAddress: "//home.jd.hk/asyn/insertAddressInfo.do",
        getAddressNameMap: "//home.jd.hk/asyn/getaddressNameMap.do",
        setDefaultAddress: "//home.jd.hk/asyn/setDefaultAdress.do",
        loadRecmdGoods: "//diviner.jd.com/diviner",
        loadRecmdShops: "//home.jd.hk/asyn/getrecommendShopsByshopId.do",
        getCommentsCnt: "//home.jd.hk/comment/count.do",
        getCommentByguid: "//home.jd.hk/comment/getByGuid.do",
        // getQiangNum: "//qiangsite.jd.com/qiangnum/mgets",
        // getFoodMsProcess: "//qiangsite.jd.com/qiangnum/mgets",
        getPromoById: "//grocer.jd.hk/getPromoById.do",
        grocerAddCart: "//grocer.jd.hk/addCart.do",
        getSkuPromoTag: "//grocer.jd.hk/getSkuPromoTag.do",
        getShopPromoTag: "//grocer.jd.hk/getShopPromoTag.do",
        getFollowingCnt: "//home.jd.hk/follow/count.do",
        getPromotingskus: "//home.jd.hk/follow/getPromoProduct.do",
        getCartNum: "//hongkong.jd.com/getCartNum.do",
        getBrowserHistory: "//hongkong.jd.com/getBrowseHistory.do",
        getCommentByskuIds: "//zy.jd.hk/getCommentCountBySkuId.html",
        getTypeBySkuId: "//search.jd.hk/getTypeBySkuId.do",
        saveIdCard: "/asyn/storeReceiverIdCard.do",
        validateUploadName: "//home.jd.hk/clearanceUpload/validateUploadName.do",
        idCardUploadSync: "//jdw.jd.hk/clearance/uploadStatus.do",
        //getStockBySkuId: '//search.jd.hk/getStockBySkuId.do',
        getCategory: "//search.jd.hk/getCategory.do",
        getGoodRateBySkuId: "//zy.jd.hk/getGoodRateBySkuId.html",
        delayReceipt:"//home.jd.hk/asyn/delayReceipt.do",
        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/pc",
        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/pc",
        saveImage: "//jicc-web.jd.com/api/component/save/pc",
        doGrant: "//home.jd.hk/asyn/idCardAuth/doGrant.do",
        getStatus: "//home.jd.hk/asyn/idCardAuth/status.do",
        getSupplyChainTrace: "//home.jd.hk/asyn/supplyChainTrace.do",

        getOrderPerson: "//home.jd.hk/order/getPurchaserInfo.html",
        getOrderEnterPerson: "//home.jd.hk/order/verifyPurchaserInfo.html",
        getOrderPersonSend: "//home.jd.hk/order/submitPurchaserInfo.html",

        getShopServer: "//chat1.jd.com/api/checkChat?",

        //预售付款：定金阶段、全款阶段、尾款（不支持优惠券）
        presaleOrderOne: "//trade.jd.hk/presale/getOrderCashierLink.action?",

        //预售尾款支持优惠券
        presaleOrderCoupon: "//trade.jd.hk/presale/end.action?",
        //商户入驻
        applyVender: "//www.jd.hk/cooperation/applySellerApplyResidence.do",
        applyFacilitator: "//www.jd.hk/cooperation/applyFacilitatorResidence.do",
        uploadFacilitator: "//www.jd.hk/cooperation/upload.do",
        submitSuccess: "//www.jd.hk/cooperation/submitSuccess.do",
        submitSuccessEn: "//www.jd.hk/cooperation/submitSuccessEn.do",
        uploadFacilitatorFile: "//www.jd.hk/cooperation/uploadFile.do"

    };

    Config.validators = {
        email: {
            regExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            errorMsg: "请填写正确的邮箱地址"
        },
        phoneNum: {
            regExp: /^1[3|4|5|7|8]\d{9}$/,
            errorMsg: "手机号码格式不正确"
        },
        idCard: {
            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
            errorMsg: "请填写正确的身份证号码"
        },
        staticPhone: {
            regExp: /^((^[0-9 -]+$)|(1[34578]\d{9}))$/,
            errorMsg: "请填写正确的固定电话"
        },
        receiver: {
            errorMsg: "请填写正确的收货人"
        },
        validateAddressDetail: {
            errorMsg: "详细地址不能为空"
        },
        money: {
            regExp: /^\d+(\.\d+)?$/,
            errorMsg: "金额格式不正确"
        },
        url: {
            regExp: /^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/,
            errorMsg: "链接格式不正确"
        },
        number: {
             regExp: /^\d+$/,
             errorMsg: "数字格式不正确"
         }
    };

    module.exports = Config;
});


// WEBPACK FOOTER //
// ./src/js/Config/Config.js